import React,{useContext, useEffect} from 'react'
import axios from 'axios'
import {Route,Navigate,useParams,useLocation} from 'react-router-dom'
import {UserContext} from '../context/UserContext'
//import Header from './components/protected/Header'
import {Container,Row,Col} from 'react-bootstrap'
import AppShell from '../shell/AppShell'
import { isTrialExpired, EXPIRED_TRIAL_PAGES } from '../access'
// import DashboardFooter from './DashboardFooter'


const PAGE_TITLES = {
    dashboard: 'Dashboard',
    favouriteplayers: 'Favourite Players',
    playerslist: 'Players List',
    lists: "Players' Lists",
    list: 'Create List',
    field: 'Field',
    plans: 'Plans',
    profile: 'Profile',
    billings: 'Billings',
    user: 'Player',
    challenges: 'Challenges',
    chatroom: 'Inbox',
    inbox: 'Inbox'
}

function titleFor(pathname){
    const segment=String(pathname||'').split('/').filter(Boolean)[0]
    return PAGE_TITLES[segment] || 'Dashboard'
}


export default function ProtectedRoute(params) {
    const {isAuth,setIsAuth}=useContext(UserContext)
    const {setToken}=useContext(UserContext)
    const location=useLocation()

    useEffect(()=>{
        if (isAuth || (sessionStorage.getItem("isAuth")==1)){
            setIsAuth(true)
        }
    },[])

    /* A trial that ran out may only open the plans and the profile. The
       server refuses everything else anyway; this sends the person somewhere
       useful instead of to a page full of refusals. */
    const page=String(location.pathname||'').split('/').filter(Boolean)[0]||'dashboard'
    const signedIn=isAuth || (sessionStorage.getItem("isAuth")==1) // eslint-disable-line eqeqeq
    if (signedIn && isTrialExpired() && EXPIRED_TRIAL_PAGES.indexOf(page)===-1){
        return <Navigate to='/plans'/>
    }

    return (
       (isAuth || (sessionStorage.getItem("isAuth")==1))
        ? <AppShell title={params.title || titleFor(location.pathname)} eyebrow={params.eyebrow}>
            <Container fluid><params.Component/></Container>
          </AppShell>
        : <Navigate to='/login'/>
    )
}
